import { FC, useState, useEffect } from "react";
import { LieuType } from "data/types";
import Avatar2 from "shared/Avatar2/Avatar2";
import EvenementBtns2 from "components/EvenementBtns2";
import Axios from '../../_services/caller.service';
import { useTranslation } from 'react-i18next';
 
export interface CardLieuIntegreBoxProps {
  className?: string;
  symbole_monnaie: string;
  author: LieuType;
  index: string;
  selected? : boolean;
  isMap?: boolean;
  onLocalisationClick?: () => void;
  numDroit: number;
}

const CardLieuIntegreBox: FC<CardLieuIntegreBoxProps> = ({
  className = "",
  symbole_monnaie,
  author,
  index,
  selected,
  isMap,
  onLocalisationClick,
  numDroit
}) => {
   const { t } = useTranslation();

  const { displayName, libelle2, prix, avatar, lat, longi } = author;
  const [lienVisible, setLienVisible] = useState("");
  const [lienItineraire, setLienItineraire] = useState("");
  const [photo, setPhoto] = useState("");
  const [showOptions, setShowOptions] = useState<boolean>(false);

  useEffect(() => {
    //gestion lien lien_modifie si createur ou visiteur et etat=R pour créateur géré par l'api
    if(author.lien !== undefined && author.lien !== "" && numDroit ===1)
    {
      setLienVisible(author.lien);
    }
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien ==="V")
    {
      setLienVisible(author.lien);
    } 
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien === "M" && author.lien_modifie !== undefined && author.lien_modifie !== "")
    {
      setLienVisible(author.lien_modifie);
    }
    
    if(author.lat !== "" && author.longi !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat+","+author.longi+"/");
    } 

  }, []);

  useEffect(() => {
   
   let imageURL: string | undefined;

    if(avatar !== "")
    {

      Axios.get(avatar, { responseType: 'blob' })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        imageURL = URL.createObjectURL(blob);
        setPhoto(imageURL);

      })
      .catch((error) => console.error('Erreur lors du chargement de l\'image', error));
    }
    else
    {
      setPhoto("");
    }

    return () => {
      if (imageURL) {
        URL.revokeObjectURL(imageURL); // Révoquez l'URL seulement lorsque le composant est démonté
      }
    };
    
  }, [avatar]);

  const afficheOptions = () => {
    setShowOptions(true);
  }

  const cacheOptions = () => {
    setShowOptions(false);
  }

  return (
    <div
      
      className={`
  ${selected ? "selectedCard" : ""}

  nc-CardLieuIntegreBox
  group
  relative
  w-full

  flex
  flex-col
  items-center
  justify-center
  text-center

  rounded-[30px]
  overflow-visible

  bg-[linear-gradient(145deg,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.94)_55%,rgba(248,250,252,0.96)_100%)]
  dark:bg-neutral-900

  border
  border-white/80
  dark:border-neutral-800

  shadow-[0_14px_32px_rgba(15,23,42,0.10),inset_0_1px_0_rgba(255,255,255,0.95)]
  hover:shadow-[0_18px_40px_rgba(15,23,42,0.14),inset_0_1px_0_rgba(255,255,255,0.95)]

  px-2
  py-3

  transition-all
  duration-300
  ease-out
  hover:-translate-y-[2px]

  ${showOptions ? "z-[9999]" : "z-1"}

  ${className}
`}
      data-nc-id="CardLieuIntegreBox"
      onMouseOver={afficheOptions}
      onMouseLeave={cacheOptions}
    >
      {/* couche visuelle de la card, clipsée aux coins */}
<div
  className="
    pointer-events-none
    absolute
    inset-0
    rounded-[30px]
    overflow-hidden
  "
>
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.95)_0%,transparent_38%),radial-gradient(circle_at_100%_100%,rgba(241,245,249,0.75)_0%,transparent_42%)]
    "
  />

  <div
    className="
      absolute
      inset-[1px]
      rounded-[29px]
      border
      border-white/80
    "
  />

  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      shadow-[inset_0_-10px_22px_rgba(15,23,42,0.035)]
    "
  />
</div>
     
     { (author.bloc !== "" || author.document !== "" || author.place_id !== "" || lienVisible || lienItineraire) && (
      <EvenementBtns2 optionsVisibles={false} className = "right-3 top-2 w-4 h-4"
      lienVisible={lienVisible}  placeId={author.place_id} placeNom={displayName} latitude={author.lat} longitude={author.longi} lienItineraire={lienItineraire} index={index || '' }/>
      )}
     
      <div className="relative z-10 w-full mt-2">
  {/* TITRE */}
  {displayName !== "" && (
    <div className="flex items-center justify-center gap-1 text-center">
      <h2
        className="
          champInputIntegre
          leading-snug
          break-words
        "
      >
        <span>{displayName}</span>
      </h2>

      {isMap && displayName !== "" && (lat === "" || longi === "") && (
        <i
          className="las la-location-arrow text-rose-500 text-[12px] self-center"
          data-tooltip-id="myTooltip"
          data-tooltip-content={t("coordonneesGPSAbsentes")}
          data-tooltip-place="top"
          onClick={
            numDroit === 1 || numDroit === 0
              ? () =>
                  alert(
                    "Pour placer ce lieu, veuillez passer en mode modification."
                  )
              : undefined
          }
        />
      )}

      {isMap && displayName !== "" && lat !== "" && longi !== "" && (
        <i
          className="curseurPointeur las la-location-arrow text-green-500 text-[12px] self-center"
          data-tooltip-id="myTooltipLoc"
          data-tooltip-content={t("cliquezCarte")}
          data-tooltip-place="top"
          onClick={onLocalisationClick}
        />
      )}
    </div>
  )}

  {/* IMAGE : version intégrée, compacte et propre */}
  {avatar !== "" && (
    <div
      className="
        mt-2
        flex
        justify-center
      "
    >
      <Avatar2
        imgUrl={photo}
        alt={displayName}
        className="
          w-[76px]
          h-[52px]

          rounded-[18px]

          shadow-[0_8px_18px_rgba(15,23,42,0.12)]
        "
        onImageClick={cacheOptions}
      />
    </div>
  )}

  {/* DESCRIPTION pleine largeur */}
  {libelle2 !== "" && (
    <div
      className="
        mt-2
        text-center
        text-xxs
        leading-tight
        text-neutral-500
        dark:text-neutral-400
        break-words
      "
      style={{ whiteSpace: "pre-line" }}
    >
      {libelle2}
    </div>
  )}
</div>
      {!isMap && prix !== "" && Number(prix) !== 0 ? (
  <div
    className={`
      relative
      z-10
      w-full

      mt-1

      pt-2

      border-t
      border-neutral-100
      dark:border-neutral-800

      flex
      items-center
      justify-center

      text-xxs
      text-neutral-900
      dark:text-white
    `}
  >
    <span className="whitespace-nowrap">
      {prix} {symbole_monnaie}
    </span>
  </div>
) : null}
    </div>
  );
};

export default CardLieuIntegreBox;
